import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import iconSearch from '../assets/figma-home/icon-search.svg';
import { useLanguage } from '../context/LanguageContext';
import { getAllProducts } from '../utils/productService';
import { localizeProduct } from '../utils/localizeProduct';

const MAX_RESULTS = 8;

// Produktet merren një herë (në fokus të parë) dhe ruhen për kërkimet e tjera.
let productsPromise = null;
const loadProducts = () => {
  if (!productsPromise) {
    productsPromise = getAllProducts().catch((err) => {
      productsPromise = null;
      throw err;
    });
  }
  return productsPromise;
};

const HeaderSearch = ({ className = '', onNavigate }) => {
  const navigate = useNavigate();
  const { t, lang } = useLanguage();
  const [query, setQuery] = useState('');
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  const ensureLoaded = () => {
    loadProducts().then(setProducts).catch(() => {});
  };

  useEffect(() => {
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const q = query.trim().toLowerCase();
  const results = q
    ? products
        .map((p) => localizeProduct(p, lang))
        .filter((p) => (p.name || '').toLowerCase().includes(q))
        .slice(0, MAX_RESULTS)
    : [];

  const goTo = (id) => {
    setOpen(false);
    setQuery('');
    if (onNavigate) onNavigate();
    navigate(`/product/${id}`);
  };

  return (
    <div className={`search-wrap ${className}`} ref={wrapRef}>
      <div className="search-field">
        <img src={iconSearch} alt="" className="search-field-icon" />
        <input
          type="text"
          className="search-field-input"
          value={query}
          placeholder={t('header.search')}
          onChange={(e) => { setQuery(e.target.value); setOpen(true); }}
          onFocus={() => { ensureLoaded(); setOpen(true); }}
          onKeyDown={(e) => {
            if (e.key === 'Escape') setOpen(false);
            if (e.key === 'Enter' && results.length > 0) goTo(results[0].id);
          }}
        />
      </div>
      {open && q && (
        <div className="search-dropdown">
          {results.length === 0 ? (
            <div className="search-empty">{t('header.searchEmpty')}</div>
          ) : (
            results.map((p) => (
              <div key={p.id} className="search-row" onClick={() => goTo(p.id)}>
                <img
                  className="search-row-img"
                  src={p.imageUrls && p.imageUrls[0]}
                  alt=""
                />
                <span className="search-row-name">{p.name}</span>
                <span className="search-row-price">€{Number(p.price).toFixed(2)}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default HeaderSearch;
